module.exports = __webpack_public_path__ + "static/media/header-checkerboard-manager.8fa7fe98.svg";